module.exports = __webpack_public_path__ + "static/media/sort-desc.67c05015.svg";